import React from 'react'

//
import Metatags from '../metatags'

import CountrySwitcher from './country-switcher'
import { buildPageMetaTags } from '../../utils/seo'

const Layout = ({
  children,
  seoData,
  marketsSlugs = {},
  langSlugs = {},
  allMarkets = {},
  countrySwitcher = true,
  location,
  siteMetadata = {},
  paths = {}
}) => {
  const pageMetaTags = buildPageMetaTags({
    seoData: seoData,
    siteMetadata: siteMetadata
  })

  return (
    <>
      <Metatags {...pageMetaTags} langSlugs={langSlugs} location={location} paths={paths} />
      <main>{children}</main>
      {countrySwitcher ? (
        <CountrySwitcher marketsSlugs={marketsSlugs} allMarkets={allMarkets} />
      ) : null}
    </>
  )
}

export default Layout
